/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixture_Confirm_RemoveInputs */

const th_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบการแข่งขันนี้หรือไม่ ผู้ตัดสินที่มอบหมายไว้จะถูกลบไปด้วย`)
};

const en_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove this fixture? Its referee assignments go with it.`)
};

const ja_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この試合を削除しますか？割り当て済みの審判も削除されます。`)
};

const zh_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除这场比赛？裁判指派会一并消失。`)
};

const es_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar este partido? Sus designaciones de árbitro se eliminan con él.`)
};

const pt_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover este jogo? As escalações de árbitro vão junto.`)
};

const id_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus pertandingan ini? Penugasan wasitnya ikut terhapus.`)
};

const fr_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer ce match ? Ses désignations d’arbitre partent avec.`)
};

const tl_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alisin ang larong ito? Kasama ang mga naitalagang referee.`)
};

const vi_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá trận này? Các phân công trọng tài cũng mất theo.`)
};

const ko_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 경기를 삭제할까요? 심판 배정도 함께 사라집니다.`)
};

const de_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Spiel entfernen? Die Schiedsrichteransetzungen gehen mit.`)
};

const ru_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить этот матч? Назначения судей исчезнут вместе с ним.`)
};

const tr_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu maç kaldırılsın mı? Hakem atamaları da gider.`)
};

const it_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere questa partita? Spariscono anche le designazioni arbitrali.`)
};

const pl_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunąć ten mecz? Znikną też obsady sędziowskie.`)
};

const uk_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити цей матч? Призначення суддів зникнуть разом із ним.`)
};

const hi_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह मैच हटाएँ? रेफ़री की नियुक्तियाँ भी चली जाएँगी।`)
};

const ar_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف هذه المباراة؟ ستُحذف معها تعيينات الحكام.`)
};

const ms_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buang perlawanan ini? Tugasan pengadil turut hilang.`)
};

const bn_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই খেলা সরাবেন? রেফারি নিয়োগও চলে যাবে।`)
};

const zh_tw2_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除這場比賽？裁判指派也會一併消失。`)
};

const zh_hk2_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除這場比賽？裁判指派也會一併消失。`)
};

const ur_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ میچ ہٹائیں؟ ریفری کی تقرری بھی ختم ہو جائے گی۔`)
};

const fa_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این بازی حذف شود؟ تعیین داوران هم از بین می‌رود.`)
};

const sw_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondoa mchezo huu? Upangaji wa marefa utaondoka pia.`)
};

const nl_fixture_confirm_remove = /** @type {(inputs: Fixture_Confirm_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze wedstrijd verwijderen? De aanwijzingen van scheidsrechters gaan mee.`)
};

/**
* | output |
* | --- |
* | "Remove this fixture? Its referee assignments go with it." |
*
* @param {Fixture_Confirm_RemoveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const fixture_confirm_remove = /** @type {((inputs?: Fixture_Confirm_RemoveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixture_Confirm_RemoveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_fixture_confirm_remove(inputs)
	if (locale === "ja") return ja_fixture_confirm_remove(inputs)
	if (locale === "zh") return zh_fixture_confirm_remove(inputs)
	if (locale === "es") return es_fixture_confirm_remove(inputs)
	if (locale === "pt") return pt_fixture_confirm_remove(inputs)
	if (locale === "id") return id_fixture_confirm_remove(inputs)
	if (locale === "fr") return fr_fixture_confirm_remove(inputs)
	if (locale === "tl") return tl_fixture_confirm_remove(inputs)
	if (locale === "vi") return vi_fixture_confirm_remove(inputs)
	if (locale === "ko") return ko_fixture_confirm_remove(inputs)
	if (locale === "de") return de_fixture_confirm_remove(inputs)
	if (locale === "ru") return ru_fixture_confirm_remove(inputs)
	if (locale === "tr") return tr_fixture_confirm_remove(inputs)
	if (locale === "it") return it_fixture_confirm_remove(inputs)
	if (locale === "pl") return pl_fixture_confirm_remove(inputs)
	if (locale === "uk") return uk_fixture_confirm_remove(inputs)
	if (locale === "hi") return hi_fixture_confirm_remove(inputs)
	if (locale === "ar") return ar_fixture_confirm_remove(inputs)
	if (locale === "ms") return ms_fixture_confirm_remove(inputs)
	if (locale === "bn") return bn_fixture_confirm_remove(inputs)
	if (locale === "zh-TW") return zh_tw2_fixture_confirm_remove(inputs)
	if (locale === "zh-HK") return zh_hk2_fixture_confirm_remove(inputs)
	if (locale === "ur") return ur_fixture_confirm_remove(inputs)
	if (locale === "fa") return fa_fixture_confirm_remove(inputs)
	if (locale === "sw") return sw_fixture_confirm_remove(inputs)
	if (locale === "nl") return nl_fixture_confirm_remove(inputs)
	return en_fixture_confirm_remove(inputs)
});